import _toConsumableArray from "/Users/Bas/repos/projects/catafolk/website/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { getLabel } from '../plugin-common/output/label';
import { format as getName } from '@citation-js/name';

var getComparisonValue = function getComparisonValue(obj, prop) {
  var label = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : prop === 'label';
  var value = label ? getLabel(obj) : obj[prop];

  switch (prop) {
    case 'author':
    case 'editor':
      return value.map(function (name) {
        return name.literal || name.family || getName(name);
      });

    case 'accessed':
    case 'issued':
      return value['date-parts'][0];

    case 'page':
      return value.split('-').map(function (num) {
        return parseInt(num);
      });

    case 'edition':
    case 'issue':
    case 'volume':
      value = parseInt(value);
      return !isNaN(value) ? value : -Infinity;

    default:
      return value || -Infinity;
  }
};

var compareProp = function compareProp(entryA, entryB, prop) {
  var flip = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : /^!/.test(prop);
  prop = prop.replace(/^!/, '');
  var a = getComparisonValue(entryA, prop);
  var b = getComparisonValue(entryB, prop);
  return (flip ? -1 : 1) * (a > b ? 1 : a < b ? -1 : 0);
};

var getSortCallback = function getSortCallback() {
  for (var _len = arguments.length, props = new Array(_len), _key = 0; _key < _len; _key++) {
    props[_key] = arguments[_key];
  }

  return function (a, b) {
    var keys = props.slice();
    var output = 0;

    while (!output && keys.length) {
      output = compareProp(a, b, keys.shift());
    }

    return output;
  };
};

var sort = function sort() {
  var method = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var log = arguments.length > 1 ? arguments[1] : undefined;

  if (log) {
    this.save();
  }

  this.data.sort(typeof method === 'function' ? method : getSortCallback.apply(void 0, _toConsumableArray(method).concat(['label'])));
  return this;
};

export { sort };